module.exports = __webpack_public_path__ + "img/close.c61db99f.svg";